import { FormEvent } from 'react'
import { useParams } from 'react-router-dom'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useToast } from '../../../../components/ui/use-toast'
import { teamsService } from '../../../../../app/services/teamsService'

export const useRemoveSellerController = () => {
  const queryClient = useQueryClient()
  const { id } = useParams()
  const { toast } = useToast()

  const { mutateAsync, isPending } = useMutation({
    mutationKey: ['deleteSeller'],
    mutationFn: async ({
      teamId,
      memberId,
    }: {
      teamId: string
      memberId: string
    }) => await teamsService.removeTeamMember(teamId, memberId),
    onSuccess() {
      queryClient.resetQueries({
        queryKey: ['Allsellers', { teamIds: id }],
      })
      queryClient.invalidateQueries({
        queryKey: ['teamId', id],
      })
    },
  })

  const handleRemoveSeller = async (
    event: FormEvent<HTMLFormElement>,
    memberId: string,
  ) => {
    event.preventDefault()
    try {
      const response = await mutateAsync({ teamId: id!, memberId })

      if (response.success) {
        toast({
          title: 'Usuário removido com sucesso',
        })
      }
    } catch (error) {
      console.log(error)
      toast({
        variant: 'destructive',
        title: 'Erro ao remover o usuário, tente novamente mais tarde.',
      })
    }
  }

  return {
    handleRemoveSeller,
    isPending,
  }
}
